/**
 * Copyright 2022 (C) Blink - All Rights Reserved
 *
 * This source code is protected under international copyright law.  All rights
 * reserved and protected by the copyright holders.
 * All files are confidential and only available to authorized individuals with the
 * permission of the copyright holders. If you encounter any file and do not have
 * permission, please get in touch with the copyright holders and delete this file.
 */
import LoadingScreen from "components/ui/LoadingScreen/LoadingScreen";
import { ErrorPage } from "pages";
import { useAuth, useRole } from "state";

const FallbackManager = () => {
  const { isLoading: isRoleLoading } = useRole();
  const { isLoading: isAuthLoading } = useAuth();
  if (isRoleLoading || isAuthLoading) {
    return <LoadingScreen test-id="v1m6HshM" />;
  }

  return <ErrorPage test-id="aPXlVkd_" />;
};

export default FallbackManager;
